// extracted by mini-css-extract-plugin
export default {"placeholder":"AccountManagementRecordLoader_placeholder__5LDxl"};